// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__IY7tF","footer":"ModalUpdate_footer__3251I"};